<template>
  <div class="recovery preloader-container">
    <div v-show="isRecoveryLoading" class="recovery__preloader preloader">
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <user-name-form
      v-show="!isRecoveryCodeSent && !isTokenReceived"
      @fetchRecoveryCode="fetchRecoveryCode"
      @setUserName="setUserName"
    />
    <recovery-code-form
      v-show="isRecoveryCodeSent && !isTokenReceived"
      @fetchRecoveryCode="fetchRecoveryCode"
      @checkRecoveryCode="checkRecoveryCode"
      @setRecoveryCode="setRecoveryCode"
      @timerExpire="handleTimerExpire"
      :isTimerGoingOn="isTimerGoingOn"
    />

    <change-password-form v-if="isTokenReceived" />
    <p class="recovery__error">{{ $t(recoveryErrorMessage) }}</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { HalfCircleSpinner } from "epic-spinners";
import RecoveryUserNameForm from "@/components/auth/RecoveryUserNameForm";
import RecoveryCodeForm from "@/components/auth/RecoveryCodeForm";
import ChangePasswordForm from "@/components/auth/ChangePasswordForm";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "user-name-form": RecoveryUserNameForm,
    "recovery-code-form": RecoveryCodeForm,
    "change-password-form": ChangePasswordForm
  },
  data() {
    return {
      userName: "",
      recoveryCode: "",
      isTimerGoingOn: false
    };
  },
  computed: {
    ...mapGetters([
      "isRecoveryCodeSent",
      "isTokenReceived",
      "recoveryErrorMessage",
      "isRecoveryLoading"
    ])
  },
  methods: {
    fetchRecoveryCode() {
      // Запускаем таймер
      this.isTimerGoingOn = true;
      this.$store.dispatch("fetchRecoveryCode", this.userName);
    },
    checkRecoveryCode() {
      this.$store.dispatch("checkRecoveryCode", {
        userName: this.userName,
        recoveryCode: this.recoveryCode
      });
    },
    setUserName(userName) {
      this.userName = userName;
    },
    setRecoveryCode(code) {
      this.recoveryCode = code;
    },
    handleTimerExpire() {
      // Устанавливаем флаг isTimerGoingOn в false, чтобы скрыть таймер
      this.isTimerGoingOn = false;
    }
  },
  destroyed() {
    this.$store.dispatch("clearRecoveryData");
  }
};
</script>

<style scoped>
.recovery {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: #222c44;
}

.recovery__preloader {
  background-color: rgba(47, 58, 87, 0.5);
}

.recovery__error {
  margin: 30px 0 0;
  text-align: center;
  color: #ef4748;
}
</style>
